import { render, staticRenderFns } from "./LessonStatisticsCard.vue?vue&type=template&id=127a09b4&scoped=true&"
import script from "./LessonStatisticsCard.vue?vue&type=script&lang=js&"
export * from "./LessonStatisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./LessonStatisticsCard.vue?vue&type=style&index=0&id=127a09b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a09b4",
  null
  
)

export default component.exports